<div class="content-modal">
  <h2 mat-dialog-title>{{'secure.orders.in_devolution.action_confirm_receipt.title_dialog' | translate}}</h2>
  <mat-dialog-content>{{'secure.orders.in_devolution.action_confirm_receipt.body_dialog' | translate}}
  </mat-dialog-content>
  <mat-dialog-actions class="button-content">
    <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
    <button mat-button color="primary" [mat-dialog-close]="true">{{'actions.close' | translate}}</button>
  </mat-dialog-actions>
</div>
